import { useFormat } from 'vivat';

import useInvoiceStatus from '@/useInvoiceStatus';
import usePayment from '@/usePayment';

const { invoiceStatusClassMap, translate } = useInvoiceStatus();
const { translate: paymentMethodTranslate } = usePayment();

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _selectorControls: {
      width: '2rem',
      // name: 'SELECT',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    code: {
      name: 'เลขที่รายการวางบิล',
      width: '10rem',
    },
    status: {
      name: 'สถานะ',
      width: '8rem',
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return invoiceStatusClassMap(val);
        },
      },
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return translate(val);
      },
    },
    amount: {
      name: 'จำนวนเงิน',
      width: '6rem',
      class: 'text-right',
      filter: (val: string, row: any) => useFormat.number(parseInt(val, 10) - parseInt(row.item.amount, 10)).currency(),
    },
    'deliveries.length': {
      name: 'จำนวนรายการ',
      width: '8rem',
      class: 'text-center',
    },
    // discount: {
    //   name: 'ส่วนลด',
    //   width: '6rem',
    //   class: 'text-right',
    //   filter: (val: string) => useFormat.number(val).currency(),
    // },
    createdAt: {
      name: 'วันที่สร้างรายการ',
      width: '12rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    'debtor.name': {
      name: 'ชื่อลูกหนี้',
      width: '16rem',
    },
    type: {
      name: 'ประเภทการชำระ',
      width: '8rem',
      class: 'text-center',
      filter: (val: string) => paymentMethodTranslate(val),
    },
    dueDate: {
      name: 'กำหนดชำระ',
      width: '8rem',
      class: 'text-center',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    date: {
      name: 'วันที่บันทึกการชำระ',
      width: '9rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string, row: any) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    'createdBy.name': {
      name: 'ผู้ทำรายการ',
      width: '10rem',
      class: 'text-right',
    },
  },
  sortable: [
    'status',
    'createdAt',
    'code',
    'deliveries.length',
    'debtor.name',
    'amount',
    'type',
    'dueDate',
    'date',
    'createdBy',
  ],
};
